import {Helmet} from 'react-helmet';
import AboutUs from "../aboutus";
import Contact from "../contact";

const faqsContent = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  "mainEntity": [
    {
      "@type": "Question",
      "name": "What is content marketing?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Content marketing is a digital strategy that involves creating and sharing valuable, relevant content to attract and engage a target audience, ultimately driving profitable customer actions."
      }
    },
    {
      "@type": "Question",
      "name": "Why is content marketing important for my business?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Content marketing helps increase brand awareness, improve SEO rankings, build trust with your audience, and drive more traffic and leads to your website."
      }
    },
    {
      "@type": "Question",
      "name": "Do you provide SEO-friendly content?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes, all content is optimized for search engines using keyword research, on-page SEO techniques, and readability best practices."
      }
    },
    {
      "@type": "Question",
      "name": "What types of content do you create?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "I offer blog writing, landing page content, product descriptions, social media copy, email campaigns, and more — all tailored to your business goals."
      }
    },
    {
      "@type": "Question",
      "name": "How can I get started with your content marketing services?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Simply contact me through the website or WhatsApp to discuss your goals. I will create a custom content strategy and provide a quote."
      }
    }
  ]
}

function App1() {
  return (
   <>
   <Helmet>
    <script type="application/ld+json">
          {JSON.stringify(faqsContent)}
        </script>
<title>Content Marketing Services in Gurgaon | Pankaj - Freelance Digital Marketer</title>

<meta name="description" content="Boost your brand visibility and engagement with result-driven content marketing services in Gurgaon. Blog posts, SEO content, email copy, and more by Pankaj." />

<meta name="keywords" content="content marketing gurgaon, freelance content marketing, content strategy, seo content writing, content marketing services in delhi, blog writing, copywriting services, digital marketing gurgaon, content writing company, inbound marketing" />

<meta property="og:title" content="Content Marketing Services in Gurgaon | Pankaj" />
<meta property="og:description" content="Grow your business with professional content marketing services in Gurgaon. From blogs to email campaigns, get SEO-friendly content that converts." />
<meta property="og:site_name" content="Pankaj | Freelance Digital Marketer" />
<meta property="og:url" content="https://www.pankj.com/content-marketing" />
<meta property="og:image" content="https://www.pankj.com/assets/img/dpnew.jpg" />

<meta name="twitter:image" content="https://www.pankj.com/assets/img/dpnew.jpg" />
<meta name="twitter:title" content="Content Marketing Services in Gurgaon | Pankaj" />
<meta name="twitter:description" content="Freelance content marketing expert in Gurgaon offering SEO content writing, blog strategy, and inbound marketing services." />

<link rel="canonical" href="https://www.pankj.com/content-marketing" />

</Helmet>
    <section id="hero" className="hero d-flex align-items-center fixedabove">
   <video
                className="mainsliderbg"
                autoPlay
                muted
                loop={true} style={{width:'100%'}}>
{/*                <source src="assets/img/bg.mp4" type="video/mp4" />*/}
                <source src="assets/img/pankaj-web-designer2.mp4" type="video/mp4" />
                <source src="bg.ogg" type="video/ogg" />
  </video>
<div className="mainsliderbg">
     <div className="container-fluid">
      <div className="row">
        <div className="col-lg-6 d-flex flex-column">
            <img src="../assets/img/thyear.webp" className="imgsz" alt="Website Designer" />
 <h1 className="multiple_effects fzsml" id="text3d">Content Marketing</h1>
          <div className="content_sec" data-aos="fade-up" data-aos-delay="400">Take a look at some of my works, and if you like them, feel free to contact me.</div>
  <div data-aos="fade-up" data-aos-delay="600">
            <div className="text-center text-lg-start">
              <a href="https://api.whatsapp.com/send?phone=917838704822&text=Hello%20Pankaj" target="_blank" rel="noreferrer" className="btn-get-started scrollto d-inline-flex align-items-center justify-content-center align-self-center">
                <span>WhatsApp</span>
                <i className="bi bi-arrow-right"></i>
              </a>
            </div>
          </div>
        </div>
        <div className="col-lg-6 hero-img" data-aos="zoom-out" data-aos-delay="200">
              <div className="img-area">
      <div className="inner-area">
        <img src="../assets/img/123.png" alt="best web designer in gurgaon" />
      </div>
    </div>
        </div>
      </div>
    </div> 
</div>
  </section>   

    <main id="main">
 <section id="pageContent" className="pageContent">

      <div className="container" data-aos="fade-up">
        <header className="section-header">
          <h2>Content Marketing</h2>
        </header>

        <div className="row">
          <div className="col-lg-12">

<div class="intro-section py-5">
  <div class="container">
    <h2>What Is Content Marketing?</h2>
    <p>Content marketing is the strategic creation and distribution of valuable, relevant content to attract and retain a clearly defined audience — and ultimately, drive profitable customer action. Whether it’s blog posts, landing pages, social media copy, or email campaigns, content is the backbone of your online presence.</p>
  </div>
</div>

<div class="services-section py-5">
  <div class="container">
    <h2>My Content Marketing Services Include</h2>
    <ul>
      <li>✅ Blog Writing & Topic Research</li>
      <li>✅ Website & Landing Page Copywriting</li>
      <li>✅ Product Descriptions & Service Pages</li>
      <li>✅ SEO-Optimized Content Strategy</li>
      <li>✅ Email Newsletter Content</li>
      <li>✅ Social Media Post Copywriting</li>
      <li>✅ Keyword Research & Content Planning</li>
      <li>✅ Content Audit & Optimization</li>
    </ul>
  </div>
</div>

<div class="why-choose-me py-5">
  <div class="container">
    <h2>Why Choose Me for Content Marketing?</h2>
    <p>✔ 11+ years of digital marketing experience<br/>
       ✔ Deep understanding of SEO and user intent<br/>
       ✔ 100% original, plagiarism-free content<br/>
       ✔ Freelance service — direct communication, better value<br/>
       ✔ Trusted by startups, SMEs, and digital agencies</p>
  </div>
</div>

<div class="faqs-section py-5">
  <div class="container">
    <h2>Frequently Asked Questions</h2>

    <div class="faq-item">
      <h3>What is content marketing?</h3>
      <p>Content marketing is a strategy where you create valuable, informative, and relevant content to attract and convert your ideal audience into customers.</p>
    </div>

    <div class="faq-item">
      <h3>Why does my business need content marketing?</h3>
      <p>It helps improve SEO rankings, drive organic traffic, build trust, and convert website visitors into leads and customers over time.</p>
    </div>

    <div class="faq-item">
      <h3>What type of content do you create?</h3>
      <p>I create blogs, landing page content, email campaigns, product/service pages, and more — fully optimized for both users and search engines.</p>
    </div>

    <div class="faq-item">
      <h3>Is the content SEO-optimized?</h3>
      <p>Yes. I use keyword research, readability guidelines, internal linking, and on-page SEO techniques in every piece of content.</p>
    </div>

    <div class="faq-item">
      <h3>How do I get started?</h3>
      <p>Just contact me through the website or WhatsApp. I’ll understand your goals and prepare a content plan tailored to your business.</p>
    </div>
  </div>
</div>

<div class="cta-section py-5 text-center">
  <div class="container">
    <h2>Let’s Tell Your Brand Story</h2>
    <p>High-quality content builds trust and drives results. Let’s grow your business with a powerful content marketing strategy.</p>
    <a href="/contact" class="btn btn-success mt-3">Book Free Consultation</a>
  </div>
</div>

          </div>

        </div>
      </div>

    </section>
    <Contact /> 
    </main>
    </>
  );
}
export default App1;
